import {
  GET_GROUPS_SUCCESS,
  GET_CHATS_SUCCESS,
  GET_GROUPS_FAIL,
  GET_CHATS_FAIL,
  GET_CONTACTS_SUCCESS,
  GET_CONTACTS_FAIL,
  GET_MESSAGES_SUCCESS,
  GET_MESSAGES_FAIL,
  POST_ADD_MESSAGE_SUCCESS,
  POST_ADD_MESSAGE_FAIL,
  GET_CHAT_POLLING_SUCCESS,
  GET_CHAT_POLLING_FAIL,
  GET_CHATS_REQUEST,
  GET_MESSAGES_REQUEST,
  POST_ADD_MESSAGE_REQUEST,
} from "./actionTypes"

const INIT_STATE = {
  chats: [
    // { id: 1, name: "Alice", status: "online", roomId: 1, description: "Hey there!", time: "10:00 AM", image: "avatar1" },
    // { id: 2, name: "Bob", status: "offline", roomId: 2, description: "Busy right now", time: "09:30 AM", image: "avatar2" },
    // { id: 3, name: "Charlie", status: "online", roomId: 3, description: "What's up?", time: "11:00 AM", image: "avatar3" },
  ],
  groups: [
    { id: 1, name: "Group 1", status: "online", image: "avatar1" },
    { id: 2, name: "Group 2", status: "offline", image: "avatar2" },
  ],  
  contacts: [
    { id: 1, name: "Alice", status: "online" },
    { id: 3, name: "Bob", status: "online" },
    { id: 4, name: "Charlie", status: "online" },
  ],
  messages:[
     ],
  error: {},
  loading:{
    addMessage:false,
    chatsloading:false,
    getGroups:false,
    getContacts:false,
    getMessagesLoading:false,
    getChatPolling:false,
    addMessageLoading:false,
  }
}

const Calendar = (state = INIT_STATE, action) => {
  switch (action.type) {

    case GET_CHATS_REQUEST:
      return {
        ...state,
        loading:{
          ...state.loading,
          chatsloading:true,
        }
      }
    case GET_CHATS_SUCCESS:
      return {
        ...state,
        chats: action.payload,
        loading:{
          ...state.loading,
          chatsloading:false,
        }
      }

    case GET_CHATS_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:{
          ...state.loading,
          chatsloading:false,
        }
      }

    case GET_GROUPS_SUCCESS:
      return {
        ...state,
        groups: action.payload,
      }

    case GET_GROUPS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_CONTACTS_SUCCESS:
      return {
        ...state,
        contacts: action.payload,
      }

    case GET_CONTACTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_MESSAGES_REQUEST:
      return {
        ...state,
        loading:{
          ...state.loading,
          getMessagesLoading:true,
        }
      }

    case GET_MESSAGES_SUCCESS:
      return {
        ...state,
        messages: action.payload,
        loading:{
          ...state.loading,
          getMessagesLoading:false,
        }
      }

    case GET_MESSAGES_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:{
          ...state.loading,
          getMessagesLoading:false,
        }
      }

    case POST_ADD_MESSAGE_REQUEST:
      return {
        ...state,
        loading:{
          ...state.loading,
          addMessageLoading:true,
        }
      }

    case POST_ADD_MESSAGE_SUCCESS:
      return {
        ...state,
        messages: [...state.messages, ...action.payload],
        loading:{
          ...state.loading,
          addMessageLoading:false,
        }
      }

    case POST_ADD_MESSAGE_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:{
          ...state.loading,
          addMessageLoading:false,
        }
      }
      //polled messages update
      case GET_CHAT_POLLING_SUCCESS:
        console.log("pooing action.payload",action.payload)
        return {
          ...state,
          messages: [...state.messages, ...action.payload],  
        }

    default:
      return state
  }
}

export default Calendar
